<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ed6jMS/tc-custom/9781788631044.jpg?1704568363503" alt="This image is the cover for the book Dead in the Water, A Campbell and Carter Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead in the Water, A Campbell and Carter Mystery
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In a sleepy Cotswold village, heavy rains reveal the body of a barmaid and troubling mystery for a local police inspector.</b></p><p> As Christmas approaches in the sleepy English village of Weston Saint Ambrose, the rains bring the wettest winter on record and the farmer’s fields are submerged. The water uncovers all manner of things, however, including a dead body, dredged up from its watery grave. </p><p> Reclusive writer Neil Stewart is shocked to find the victim snagged on the jetty at his house, and even more surprised when he recognizes her. And he’s not the only one. When Inspector Jess Campbell investigates, she recognizes the body of Courtney Higson—a local barmaid with a doting, ex-con father, Terry. He is set on finding his daughter’s killer, and Jess must get to the bottom of this quickly, before he takes the law into his own hands . . . </p><p><b>Perfect for fans of T. E. Kinsey and Ann Cleeves.</b></p><p><b>Praise for <i>Dead in the Water</i></b></p><p><i><b>“Think . . . <i>Midsomer Murders</i>—but without the hammy horror and unfeasibly high body count—add a cast of seductively real characters and a large helping of super sleuthing, and you have the fourth Campbell and Carter murder mystery from one of the nation’s best-loved crime writers.” —<i>Blackpool Gazette</i></b></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Granger
      </h2>
      
      <p class="authorDescription body article"><P>Ann Granger is a British author of cozy crime. Born in Portsmouth, England, she went on to study at the University of London. She has written over thirty murder mysteries, including the Mitchell &amp; Markby Mysteries, the Fran Varady Mysteries, the Lizzie Martin Mysteries and the Campbell and Carter Mysteries. Her books are set in Britain, and feature female detectives, murderous twists and characters full of humor and color.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25016346